<main class="service-app">
	<div class="scroll-container">
		<app-vinavon-button>
			<button (click)="openKalender()" class="medium" mat-fab matTooltip="{{'MAIN_APP_SERVICE_APP.kalender' | translate}}" style="background-color: #ffffff">
				<mat-icon class="low">calendar_month</mat-icon>
			</button>
			
			<button (click)="openMaterial()" [disabled]="!(currTerminExists$ | async)" class="medium" mat-fab matTooltip="{{'MAIN_APP_SERVICE_APP.material' | translate}}"
			        style="background-color: #ffffff">
				<mat-icon class="low">home_improvement_and_tools</mat-icon>
			</button>
			
			<button (click)="addWorkingHours()" class="medium" mat-fab matTooltip="{{'MAIN_APP_SERVICE_APP.zeitErfassen' | translate}}" style="background-color: #ffffff">
				<mat-icon class="low">more_time</mat-icon>
			</button>
			
			<button (click)="openFotos()" [disabled]="!(currTerminExists$ | async)" class="medium" mat-fab matTooltip="{{'MAIN_APP_SERVICE_APP.fotos' | translate}}" style="background-color: #ffffff">
				<mat-icon class="low">imagesmode</mat-icon>
			</button>
			
			<button (click)="openDokumente()" [disabled]="!(currTerminExists$ | async)" class="medium" mat-fab matTooltip="{{'MAIN_APP_SERVICE_APP.dokumente' | translate}}"
			        style="background-color: #ffffff">
				<mat-icon class="low">file_present</mat-icon>
			</button>
			
			<button (click)="openRapport()" [disabled]="!(currTerminExists$ | async)" class="medium" mat-fab matTooltip="{{'MAIN_APP_SERVICE_APP.rapport' | translate}}"
			        style="background-color: #ffffff">
				<mat-icon class="low">contract_edit</mat-icon>
			</button>
			
			<button class="medium" mat-fab style="background-color: #ffffff; visibility: hidden">
				<mat-icon class="low"></mat-icon>
			</button>
			
			<button (click)="openZeiten()" class="medium" mat-fab matTooltip="{{'MAIN_APP_SERVICE_APP.zeiten' | translate}}" style="background-color: #ffffff">
				<mat-icon class="low">schedule</mat-icon>
			</button>
			
			<button (click)="openAuftraege()" class="medium" mat-fab matTooltip="{{'MAIN_APP_SERVICE_APP.aufträge' | translate}}" style="background-color: #ffffff">
				<mat-icon class="low">book_3</mat-icon>
			</button>
		
		</app-vinavon-button>
		
		<mat-card appearance="outlined" style="padding: 0 16px">
			<div class="contentBox">
				<div *ngIf="selectedAppointment$ | async as appointment; else noAppointmentSelected" class="row">
					<div>
						<span><span style="font-weight: bold">{{ "MAIN_APP_SERVICE_APP.beschreibung" | translate }}: </span>{{ appointment.objectNumber + '(' + appointment.objDescription + ') ' }}</span>
						<span> | </span>
						<span><span style="font-weight: bold">{{ "MAIN_APP_SERVICE_APP.customer" | translate }}: </span>{{ getOrderCustomerLine(appointment.objectID) }}
						</span></div>
					<div>
						<span *ngIf="appointment.note4"><span style="font-weight: bold">{{ "MAIN_APP_SERVICE_APP.note4" | translate }}: </span>{{ appointment.note4 }}</span>
						<span *ngIf="appointment.note4 && appointment.startTime && appointment.endTime"> | </span>
						<span *ngIf="appointment.startTime && appointment.endTime"><span style="font-weight: bold">{{ "MAIN_APP_SERVICE_APP.time" | translate }}: </span>{{ (appointment.startTime | date:'HH:mm') + ' - ' + (appointment.endTime | date:'HH:mm') }}</span> | <span *ngIf="appointment.projectLeader"><span style="font-weight: bold">{{ "MAIN_APP_SERVICE_APP.projectLeader" | translate }}: </span>{{ appointment.projectLeader }}</span>
					</div>
				</div>
				<span class="row" style="display: flex; column-gap: 0.5em;">
					<button (click)="createAppointment()" class="fabButtonSmall" color="primary" mat-mini-fab>
						<mat-icon>add</mat-icon>
					</button>
					<button (click)="showAppointmentDetails()" [disabled]="!(currTerminExists$ | async)" class="fabButtonSmall" color="primary" mat-mini-fab>
						<mat-icon>preview</mat-icon>
					</button>
					<button (click)="removeAppointment()" [disabled]="!(currTerminExists$ | async)" class="fabButtonSmall" color="primary" mat-mini-fab>
						<mat-icon>highlight_off</mat-icon>
					</button>
				</span>
			</div>
		</mat-card>
		
		<div class="content" style="position: relative">
			<router-outlet style="width: 100%"></router-outlet>
		</div>
	</div>
</main>


<ng-template #noAppointmentSelected>
	<div>{{ "MAIN_APP_SERVICE_APP.noAppointmentSelected" | translate }}</div>
</ng-template>